import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { UsersFilterShape } from '../../../core/models/user';
import { CacheManagementPanel } from '../components/CacheManagementPanel';
import { NotificationSender } from '../components/NotificationSender';
import { OnlineUsersChart } from '../components/OnlineUsersChart';
import { TelegramProxyLinksManager } from '../components/TelegramProxyLinksManager';
import UsersFilter from '../components/UsersFilter';
import UsersList from '../components/UsersList';
import './UserManagementScreen.css';

export const UsersMaganementScreen: React.FC<{}> = () => {
    const [draftFilter, setDraftFilter] = useState<UsersFilterShape>({});
    const [appliedFilter, setAppliedFilter] = useState<UsersFilterShape>({});

    const handleApplyFilter = () => {
        const entries = Object.entries(draftFilter)
            .filter(([, v]) => v !== undefined && v !== null && !(Array.isArray(v) && v.length === 0));
        setAppliedFilter(entries.length > 0
            ? Object.fromEntries(entries) as UsersFilterShape
            : {}
        );
        toast.info('Фильтр применен');
    };

    const handleClearFilter = () => {
        setDraftFilter({});
        setAppliedFilter({});
        toast.info('Фильтр очищен');
    };

    return (
        <div className="users-management-layout">
            <div className="users-management-chart-row">
                <OnlineUsersChart />
            </div>
            <div className="users-management-left">
                <div className="users-management-panel users-management-filter-panel">
                    <UsersFilter
                        value={draftFilter}
                        onChange={(v) => setDraftFilter(v)}
                        onApply={handleApplyFilter}
                        onClear={handleClearFilter}
                    />
                </div>
                <div className="users-management-panel users-management-list-panel">
                    <UsersList filter={appliedFilter} />
                </div>
                <TelegramProxyLinksManager />
            </div>
            <div className="users-management-right">
                <div className="users-management-panel">
                    <NotificationSender filter={appliedFilter} />
                </div>
                <CacheManagementPanel />
            </div>
        </div>
    );
};
